export default {
  tag: "Regulations & Compliance",
  title1: "Permits, Licenses &",
  title2: "Regulatory Requirements",
  subtitle:
    "A comprehensive reference guide for every permit and license required, and partner with a city to operate a food truck in Orange County, CA. All three categories — business, health, and vehicle — in one place.",
  viewFullGuide: "View Full Guide",
  ctaTitle: "Need help navigating these requirements?",
  ctaText:
    "Our team handles permit applications, renewals, and compliance tracking so you can focus on your food and your customers.",
  bookSession: "Book a Session",
  backHome: "Back to Home",
  disclaimerTitle: "Disclaimer:",
  disclaimerText:
    "Permit requirements and fees change frequently. This guide reflects current OC regulations as of 2025 and is intended for general informational purposes only. We strongly recommend booking a consultation with our team to get accurate, up-to-date guidance for your specific situation.",
  categories: [
    {
      id: "business",
      label: "Business Licenses",
      title: "Business Licenses & County Permits",
      badge: "Required Before Opening",
      items: [
        {
          name: "City Business License",
          authority: "Each City You Operate In",
          renewal: "Annually",
          note: "Required in each city you vend. Anaheim, Irvine, and Santa Ana have their own mobile vendor permits.",
        },
        {
          name: "Seller's Permit (Sales Tax)",
          authority: "California CDTFA",
          renewal: "No renewal required",
          note: "Required to collect and remit California sales tax. Apply online at cdtfa.ca.gov.",
        },
        {
          name: "Fictitious Business Name (DBA)",
          authority: "OC County Clerk-Recorder",
          renewal: "Every 5 years",
          note: "Required if you operate under a name different from your legal business name.",
        },
        {
          name: "Plan Review Applications",
          authority: "OC Environmental Health",
          renewal: "Only when modifying layout or equipment",
          note: "Submitted before construction or remodel. Must include detailed floor plans, equipment specs, and plumbing/electrical diagrams.",
        },
      ],
    },
    {
      id: "hcd-insignia",
      label: "HCD: Insignia Label",
      title: "HCD Certification & Insignia Label",
      badge: "State Mandated",
      items: [
        {
          name: "HCD 415 Application",
          authority: "California HCD / OC Environmental Health",
          renewal: "No fixed expiration — no year limitation",
          note: "State certification for mobile food units under California Health and Safety Code Section 113725. Required before county MFF permit can be issued. There is no year limitation on this certification — once approved, it remains valid indefinitely unless significant modifications are made to the unit.",
        },
        {
          name: "1980–2006 MFF Equipment Upgrade",
          authority: "California HCD",
          renewal: "One-time upgrade requirement",
          note: "Mobile Food Facilities manufactured between 1980 and 2006 are operating with outdated kitchen equipment that no longer meets current HCD standards. These units must undergo a comprehensive equipment upgrade — including commercial-grade refrigeration, ventilation, and cooking appliances — before they can receive or renew their insignia label certification.",
        },
      ],
    },
    {
      id: "health",
      label: "Health & Food Safety",
      title: "Health Permits & Food Safety Requirements",
      badge: "Strictly Enforced",
      items: [
        {
          name: "Food Handler's Card",
          authority: "OC Environmental Health",
          renewal: "Every 3 years",
          note: "All food handlers must carry a valid food handler card while working on the truck.",
        },
        {
          name: "Food Manager Certification",
          authority: "ServSafe / ANSI Accredited",
          renewal: "Every 5 years",
          note: "At least one certified food protection manager is required on-site during operating hours.",
        },
        {
          name: "OC Health Inspection",
          authority: "OC Environmental Health Division",
          renewal: "2x per year (unannounced)",
          note: "Inspectors check food temps, hygiene, equipment cleanliness, and commissary compliance.",
        },
        {
          name: "Commissary Health Approval",
          authority: "OC Environmental Health",
          renewal: "Annually",
          note: "Your commissary must also be permitted by OC Environmental Health and must match your MFF permit.",
        },
        {
          name: "Health Permit",
          authority: "OC Environmental Health",
          renewal: "Annually",
          note: "Required for all food preparation and sales operations. Covers sanitation, food storage, and equipment standards.",
        },
      ],
    },
    {
      id: "vehicle",
      label: "Vehicle & Commissary",
      title: "Vehicle, Fire Safety & Commissary Requirements",
      badge: "Pre-Launch Checklist",
      items: [
        {
          name: "DMV Commercial Vehicle Registration",
          authority: "California DMV",
          renewal: "Annually",
          note: "Your food truck must be registered as a commercial vehicle. Class B or C license may be required depending on vehicle weight.",
        },
        {
          name: "Fire Suppression System (Ansul)",
          authority: "Local Fire Department",
          renewal: "Semi-annual service inspection",
          note: "Mandatory for all cooking equipment that produces grease-laden vapors (fryers, grills, etc.).",
        },
        {
          name: "Commissary Agreement Letter",
          authority: "Licensed OC Commissary",
          renewal: "Ongoing contract",
          note: "You must return to your commissary for daily cleaning, restocking, and waste disposal. Must be within a reasonable distance of your operating area.",
        },
      ],
    },
  ],
};